export default {
  title: 'Missatut tilaukset',
  card_title: 'Missattujen tilausten sähköpostit',
  intro:
    'Jos kukaan ei hyväksy tilausta {{minutes}} minuutin kuluessa, se hylätään automaattisesti. Tämän jälkeen kaikki listalla olevat saavat sähköpostin tilauksesta, jotta joku voi hoitaa asian.',
  default: {
    owner: 'Ravintolan omistaja',
    partner: 'Kumppani',
    owner_missing: 'Ravintolan omistaja ({{email}}) ei saa näitä sähköposteja.',
    partner_missing: 'Kumppanin oletusosoite ({{email}}) ei saa näitä sähköposteja.',
  },
  empty: 'Kukaan ei saisi tietää missatuista tilauksista. Lisää vähintään yksi sähköpostiosoite tallentaaksesi.',
  save_error: 'Sähköpostien tallennus epäonnistui. Tarkista yhteytesi ja yritä uudelleen.',
  load_error: 'Sähköpostien lataus epäonnistui. Tarkista yhteytesi ja yritä uudelleen.',
  unavailable: 'Missattujen tilausten sähköpostit eivät ole käytettävissä tälle ravintolalle.',
  buttons: {
    save: 'Tallenna',
    retry: 'Yritä uudelleen',
  },
  toasts: {
    saved: 'Missattujen tilausten sähköpostit tallennettu',
  },
};
